// Active-tenant persistence. The value is mirrored in a module-level variable
// so the non-React API client can read it synchronously on every request.

const STORAGE_KEY = 'saasd.activeTenantId';

function readInitial(): string | null {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(STORAGE_KEY) ?? null;
}

let current: string | null = readInitial();

export function getActiveTenantId(): string | null {
  return current;
}

export function persistActiveTenantId(id: string | null): void {
  current = id;
  if (typeof localStorage === 'undefined') return;
  if (id) {
    localStorage.setItem(STORAGE_KEY, id);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}
